import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const DocumentEnrgytabone = () => {
    // const [activeTab, setActiveTab] = useState("tab1");

    const handleTabClick = (tab) => setActiveTab(tab);

    const navigate = useNavigate();
    const location = useLocation();

    // Extract active tab from URL
    const queryParams = new URLSearchParams(location.search);
    const initialTab = queryParams.get("activeTab") || "tab1";
    const [activeTab, setActiveTab] = useState(initialTab);



    const handleKnowMoreClick = () => {
        navigate("/carrerspage"); // Replace with the actual route you want to navigate to
    };

    // Autoplay effect to change tabs every 3 seconds (3000ms)
    useEffect(() => {
        const tabInterval = setInterval(() => {
            // setActiveTab((prevTab) => {
            //     const nextTabNum = parseInt(prevTab.replace("tab", "")) % 3 + 1; // 9 tabs in total
            //     return `tab${nextTabNum}`;
            // });
        }, 3000); // Change tab every 3 seconds

        // Clear interval when component unmounts
        return () => clearInterval(tabInterval);
    }, []);

    const styles = {
        container: {
            fontFamily: "Arial, sans-serif",
            // display: "flex",
            flexDirection: "row",
            width: "98%",
            margin: "50px auto",
            justifyContent: "space-between",
        },
        tabNav: {
            // width:"400px",
            // height:"400px",
            flexDirection: "column",
            borderRight: "1px solid #fff",

            overflowY: "auto", // Ensure only vertical scrolling
            scrollbarWidth: "thin", // For Firefox
            scrollbarColor: "#ccc transparent", // For Firefox
        },
        // Apply mobile-specific styles for tabNav


        tabButton: {
            padding: "19px",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#555",
            outline: "none",
            transition: "color 0.3s, background-color 0.3s",
            borderRadius: "10px",
            margin: "5px 0",
            backgroundColor: "#f0f0f0",
        },
        activeTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        },
        card: {
            display: "flex",
            alignItems: "center",
            padding: "20px",
            borderRadius: "15px",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            width: "100%",
            marginLeft: "10px",
        },
        image: {
            width: "382px",
            height: "354px",
            borderRadius: "10px",
            marginRight: "20px",
        },
        textContent: {
            flex: 1,
            textAlign: "left",
            color: "#333",
        },
        knowMoreButton: {
            marginTop: "15px",
            padding: "10px 20px",
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            transition: "background-color 0.3s",
            marginLeft: "150px"
        },
        dotNav: {
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
        },
        dot: {
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: "#ccc",
            margin: "0 5px",
            cursor: "pointer",
            transition: "background-color 0.3s",
        },
        activeDot: {
            backgroundColor: "rgb(236 115 34)",
        },
        // Mobile styling for tabs above content
        mobileContainer: {
            flexDirection: "column", // Stack tabs and content
        },
        mobileTabNav: {
            flexDirection: "row", // Tabs are horizontal on mobile
            justifyContent: "space-around",
            borderRight: "none", // Remove right border for mobile
        },
        mobileCard: {
            flexDirection: "column", // Stack image and text content
            alignItems: "center",
            textAlign: "center",
        },
        mobileImage: {
            width: "100%",
            height: "auto",
            marginRight: "0", // Remove right margin on mobile
        },
        mobileKnowMoreButton: {
            marginLeft: "0", // Center button on mobile
        },
        // Mobile tab navigation change
        mobileTabButton: {
            padding: "20px",
            fontSize: "14px",
            fontWeight: "normal",
            color: "#555",
            backgroundColor: "#f0f0f0",
            border: "none",
            cursor: "pointer",
            outline: "none",
            textAlign: "center",
        },
        activeMobileTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        }
    };
    const tabContent = {
        tab1: [

            { id: 1, title: " 	What is this regulation?", description: "<span style='font-size: 24px; display: inline-block; text-align: center; position: relative; top: 5px;margin-left:-14px'>*</span> The Central Electricity Authority (Cyber Security in Power Sector) Regulations, 2024 is a mandatory cybersecurity framework designed to secure critical power infrastructure from cyber threats, ensure resilience, and enhance security governance across the energy sector. <br><br><b> The regulation focuses on:  </b><ul><li>Securing power generation, transmission, and distribution networks.</li><li>Protecting Industrial Control Systems (ICS), SCADA, and Smart Grid infrastructures. </li><li>Ensuring real-time threat detection, incident response, and cyber resilience.</li><li>Enforcing compliance with global cybersecurity standards (IEC 62443, NIST CSF, and CERT-In guidelines).</li></ul>This regulation aims to protect India’s electricity grid, renewable energy systems, and operational technology (OT) environments from cyberattacks." },

            { id: 2, title: "Who is the regulatory body?", description: "<span style='font-size: 24px; display: inline-block; text-align: center; position: relative; top: 5px;margin-left:-14px'>*</span> The Central Electricity Authority (CEA) under the Ministry of Power, Government of India, is the regulatory body responsible for enforcing the Cyber Security in Power Sector Regulations, 2024. <ul><li> CEA sets cybersecurity mandates for power utilities, renewable energy firms, and grid operators.</li><li>National Critical Information Infrastructure Protection Centre (NCIIPC) oversees cybersecurity for critical infrastructure in the power sector.</li><li>CERT-In (Indian Computer Emergency Response Team) supports threat intelligence, cybersecurity audits, and incident response.</li><li>State Electricity Regulatory Commissions (SERCs) and Power Grid Corporation of India (PGCIL) ensure compliance at regional levels.</li></ul>" },
            { id: 3, title: "Who does this apply to?", description: " The CEA Cyber Security Regulations, 2024 apply to all entities involved in power generation, transmission, distribution, and grid operations.  <ul><li>Power Generation Companies (GENCOs) – Coal, hydro, nuclear, solar, and wind power plants. </li><li>Transmission Companies (TRANSCOs) – National and state transmission utilities (e.g., PGCIL, STUs).</li><li>Distribution Companies (DISCOMs) – Public and private electricity distribution utilities. </li><li>Independent Power Producers (IPPs) – Private firms supplying electricity to the national grid.</li><li>Renewable Energy Companies – Solar farms, wind power plants, and hybrid energy projects connected to the grid.</li><li>Smart Grid Operators – Companies managing IoT-based grid automation, power storage, and demand response. </li><li>Industrial & Infrastructure Firms with Captive Power Plants – Manufacturing plants, data centers, and industrial zones with in-house power generation. </li></ul>This regulation is critical for organizations managing operational technology (OT), SCADA, and grid infrastructure." },
            {
                id: 4, title: "Is compliance mandatory?", description: `<ul style="list-style: none; padding-left: 0;">
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-left: 20px;">
        <span style="font-size: 18px; display: inline-block; text-align: center; position: relative; top: 5px;">✅</span>
        <span>Yes, compliance with these regulations is mandatory for all applicable entities.</span>
    </li>
</ul>
  Power utilities and grid operators must implement security controls as per CEA mandates. <ul><li>Non-compliance can lead to financial penalties, regulatory action, or operational restrictions.Government projects, tenders, and renewable energy firms must ensure compliance to receive funding and approvals.</li><li> Entities must integrate cybersecurity measures across IT and OT systems to protect critical infrastructure.</li></ul>Failure to comply could expose India’s power grid to cyber risks, operational disruptions, and potential national security threats.` },
            { id: 5, title: "How often is an audit required?", description: "<span style='font-size: 24px; display: inline-block; text-align: center; position: relative; top: 5px;margin-left:-14px'>*</span> Annual cybersecurity audits are mandatory for all power sector organizations. <ul><li>Quarterly vulnerability assessments and penetration testing (VAPT) for high-risk OT environments. </li><li> Real-time security monitoring and compliance reporting to CEA, CERT-In, and NCIIPC.Incident response drills and cybersecurity training exercises at least once a year.</li></ul>For energy companies and critical infrastructure operators, continuous monitoring and regulatory audits are essential for compliance and risk management." },
            {
                id: 6, title: "What are the key requirements?", description: `<ul style="list-style: none; padding-left: 0;">
    <li">
        <span>The CEA Cyber Security Regulations, 2024 outline security measures across IT, OT, and industrial control systems.</span>
    </li>
</ul>

<b>Key Cybersecurity Requirements Under CEA Regulations:</b>

<ul style="list-style: none; padding-left: 0;">
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-left: 20px;">
        <span style="font-size: 18px;">✅</span>
        <span>Cyber Risk Assessment & Asset Protection – Identify critical OT assets, SCADA systems, and IT-OT convergence risks.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-left: 20px;">
        <span style="font-size: 18px;">✅</span>
        <span>Multi-Layered Network Security Architecture – Implement firewalls, Zero Trust Architecture (ZTA), and OT segmentation.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-left: 20px;">
        <span style="font-size: 18px;">✅</span>
        <span>Access Control & Identity Management – Multi-factor authentication (MFA), least privilege access (LPA), and role-based controls.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-left: 20px;">
        <span style="font-size: 18px;">✅</span>
        <span>Threat Intelligence & Real-Time Cyber Monitoring – AI-powered intrusion detection systems (IDS), SIEM, and anomaly detection.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-left: 20px;">
        <span style="font-size: 18px;">✅</span>
        <span>Data Protection & Encryption – End-to-end encryption for power sector data, cloud security, and cybersecurity for IoT-enabled smart grids.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-left: 20px;">
        <span style="font-size: 18px;">✅</span>
        <span>Incident Response & Cyber Resilience – Mandatory cyber incident reporting to CERT-In, business continuity planning (BCP), and disaster recovery (DR) strategies.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-left: 20px;">
        <span style="font-size: 18px;">✅</span>
        <span>Regular Audits, Testing, & Compliance Reviews – Annual audits, penetration testing for SCADA and ICS systems, and cybersecurity training programs.</span>
    </li>
</ul>

These security measures align with IEC 62443 (Industrial Cybersecurity), NIST CSF, and CERT-In advisories for securing critical energy infrastructure.
` },

            {
                id: 7,
                title: "Where can I find the official regulation?",
                description: `The official CEA Cyber Security Regulations, 2024, and compliance requirements can be accessed at:
          
              <ul><li>Central Electricity Authority (CEA) Official Website – https://cea.nic.in/</li>
           <li>Ministry of Power, Government of India – https://powermin.gov.in/</li>
           <li>CERT-In (Indian Computer Emergency Response Team) – https://www.cert-in.org.in/ </li>
          <li> National Critical Information Infrastructure Protection Centre (NCIIPC) – https://www.nciipc.gov.in/ </li>
          <li> Cybersecurity Guidelines for Smart Grids & Energy Infrastructure – Available from sector-specific regulators and BIS (Bureau of Indian Standards).</li>
         <li>  Organizations must refer to official documentation and industry-specific cybersecurity guidelines for detailed compliance frameworks.</li></ul>
               
                `
            },
            {
                id: 8,
                title: " 	What’s the implication to the Indian Energy & Infrastructure sector?",
                description: `For India’s energy and infrastructure sector, compliance with CEA Cyber Security Regulations is crucial for grid stability, operational security, and resilience against cyber threats. <br>
            <b>Key Implications for Energy & Infrastructure:</b>
        <ul><li>Cybersecurity for Smart Grids & Renewable Energy – As India transitions to smart grids, IoT-enabled power management, and AI-driven energy optimization, cybersecurity becomes critical for uninterrupted operations.</li>
        <li>   Risk Mitigation Against Cyberattacks – India’s power sector has been targeted by cyber threats, and these regulations help prevent ransomware, malware, and nation-state attacks. </li><li> Supply Chain Security for Power Equipment & OEMs – Power companies must ensure cybersecurity across their supply chains, covering transformers, substations, and control systems.</li><li>Regulatory Compliance & Global Trade Eligibility – Complying with CEA regulations aligns Indian power firms with international cybersecurity frameworks, enhancing credibility and trade partnerships.</li><li>Business Continuity for Power & Critical Infrastructure Operators – Ensuring resilience against cyberattacks, natural disasters, and system failures helps maintain uninterrupted energy supply.</li></ul>
               
                `
            },


        ],
        tab2: [

            { id: 1, title: " 	What is this regulation?", description: "<ul><li> The NCIIPC Guidelines for Critical Information Infrastructure (CII) Protection are a set of security measures and best practices issued by the National Critical Information Infrastructure Protection Centre (NCIIPC) of India. These guidelines aim to safeguard India's Critical Information Infrastructure (CII) from cyber threats, ensuring the security, resilience, and continuity of essential services.</li><li>The guidelines focus on cybersecurity risk management, incident response, threat intelligence sharing, and compliance frameworks for organizations identified as part of India's critical infrastructure.</li></ul>" },

            { id: 2, title: "Who is the regulatory body?", description: "<ul><li> The National Critical Information Infrastructure Protection Centre (NCIIPC), under the National Technical Research Organisation (NTRO), Government of India, is the regulatory body responsible for issuing and enforcing these guidelines.</li></ul>" },
            { id: 3, title: "Who does this apply to?", description: "  The guidelines apply to organizations designated as Critical Information Infrastructure (CII) under Section 70 of the Information Technology (IT)<br><br><b> Act, 2000. These typically include sectors vital to national security, economy, and public health, such as:</b>  <ul><li>Energy (Power, Oil & Gas, Nuclear) </li><li>Finance & Banking </li><li>Transport (Rail, Aviation, Shipping)</li><li>Telecommunications</li><li>Defense & Strategic Enterprises</li><li>Government & Public Services </li></ul>Organizations falling within these sectors must comply with the NCIIPC's security directives." },
            {
                id: 4, title: "Is compliance mandatory?", description: `<ul style="list-style: none; padding-left: 0;">
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-left: 20px;">
        <span>✅</span>
        <span>Yes, compliance is mandatory for all organizations designated as Critical Information Infrastructure (CII) under the IT Act, 2000.
        Failure to comply can result in penalties, including legal and financial consequences, as per Indian cyber laws.</span>
    </li>
</ul><ul><li>Additionally, private organizations operating in critical sectors may be required to adhere to these guidelines if they form part of the supply chain for CII entities.</li></ul>`},
            { id: 5, title: "How often is an audit required?", description: "<ul><li> Periodic cybersecurity audits are mandated under the guidelines, typically conducted annually or as per NCIIPC directives.Organizations may also be required to undergo audits after major security incidents or infrastructure changes. </li><li> Reports must be submitted to NCIIPC, and organizations must implement corrective actions as needed.</li><ul><li>Organizations may also be required to undergo audits after major security incidents or infrastructure changes.</li><li>The audits include risk assessments, penetration testing, and vulnerability management.</li></ul><li> Reports must be submitted to NCIIPC, and organizations must implement corrective actions as needed.</li></ul>" },
            { id: 6, title: "What are the key requirements?", description: "<span style='font-size: 24px; display: inline-block; text-align: center; position: relative; top: 5px;margin-left:-14px'>*</span> The NCIIPC guidelines emphasize a layered security approach for CII protection, including: <ul><li>Risk-Based Security Framework – Identifying, classifying, and securing critical assets. </li><li>Cyber Risk Assessment & Asset Protection – Identify critical OT assets, SCADA systems, and IT-OT convergence risks.  </li><li>Security Operations Center (SOC) Implementation – Continuous monitoring, threat detection, and incident response. </li><li>Access Control & Identity Management – Restricting unauthorized access to critical systems.</li><li>Network Security & Segmentation – Implementing firewalls, intrusion detection/prevention systems (IDS/IPS).</li><li>Data Security & Encryption – Securing sensitive data through encryption and access restrictions. </li><li>Supply Chain Security – Ensuring third-party vendors and contractors comply with cybersecurity requirements.</li><li>Incident Response & Reporting – Mandatory reporting of cybersecurity incidents to NCIIPC.</li><li>Threat Intelligence Sharing – Collaboration with NCIIPC and CERT-In for real-time cyber threat intelligence.</li></ul>Regular Audits & Compliance Checks – Ensuring compliance through internal and external audits." },

            {
                id: 7,
                title: "Where can I find the official regulation?",
                description: `The official NCIIPC guidelines can be accessed from:<br><br>
              📌 Official Source:
                <ul><li>   NCIIPC Website: https://nciipc.gov.in</li>
                    <li>  CERT-In (Indian Computer Emergency Response Team): https://www.cert-in.org.in</li>
                    <li>  Ministry of Electronics & Information Technology (MeitY): https://www.meity.gov.in</li>
                    <li>   Organizations registered as CII entities can request detailed compliance documents directly from NCIIPC.</li></ul>
                `
            },
            {
                id: 8,
                title: " 	What’s the implication to the Indian Energy & Infrastructure sector?",
                description: `The Energy & Infrastructure sector in India is a critical component of national security, making it a primary focus for CII protection. The implications include:  <br><br>
            Key Implications for Energy & Infrastructure:
            <ul style="list-style: none; padding-left: 0;">
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-left: 20px;">
        <span style="font-size: 18px;">✅</span>
        <span>Mandatory Cybersecurity Compliance – Power plants, oil refineries, energy grids, and major infrastructure projects must implement NCIIPC guidelines.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-left: 20px;">
        <span style="font-size: 18px;">✅</span>
        <span>Increased Cybersecurity Investments – Companies must invest in SOCs, firewalls, identity management, and secure remote access solutions.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-left: 20px;">
        <span style="font-size: 18px;">✅</span>
        <span>Operational Technology (OT) Security – Protection of industrial control systems (ICS), SCADA networks, and IoT-based energy infrastructure.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-left: 20px;">
        <span style="font-size: 18px;">✅</span>
        <span>Regulatory Reporting Requirements – Organizations must regularly audit their security posture and report incidents to NCIIPC.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-left: 20px;">
        <span style="font-size: 18px;">✅</span>
        <span>Supply Chain Impact – Contractors and vendors associated with infrastructure projects must align with cybersecurity protocols.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-left: 20px;">
        <span style="font-size: 18px;">✅</span>
        <span>Legal & Financial Repercussions – Non-compliance can result in regulatory penalties, legal actions, and reputational damage.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-left: 20px;">
        <span style="font-size: 18px;">✅</span>
        <span>Integration with Renewable Energy & Smart Grid Security – As India moves towards renewable energy, securing smart grids and IoT-enabled energy networks becomes a priority.</span>
    </li>
</ul>

                `
            },


        ],
        tab3: [

            { id: 1, title: " 	What is this regulation?", description: "<ul><li> The CERT-In Cybersecurity Directions, 2022 were issued by the Indian Computer Emergency Response Team (CERT-In) under the Ministry of Electronics and Information Technology (MeitY), Government of India. These directions mandate cybersecurity practices for organizations handling critical, sensitive, and personal data to improve cyber resilience and incident response. </li><b>These directions specifically focus on:</b><ul><li>Incident reporting timelines (within 6 hours of detection). </li><li>Mandatory log retention for 180 days in India.</li><li>Strict cybersecurity measures for critical infrastructure, including the Energy & Infrastructure sectors.</li><li>They aim to improve cyber threat visibility, response time, and compliance frameworks for organizations operating in India's digital ecosystem.</li></ul>" },

            { id: 2, title: "Who is the regulatory body?", description: "<ul><li> The Indian Computer Emergency Response Team (CERT-In), under MeitY, is the official regulatory body responsible for enforcing these cybersecurity directions.</li></ul>" },
            { id: 3, title: "Who does this apply to?", description: " These cybersecurity directions apply to a wide range of entities, including:  <ul><li>  Critical Information Infrastructure (CII) (as defined by NCIIPC).</li><li>Energy sector entities (power plants, grid operators, refineries, renewable energy firms).</li><li>Infrastructure & Construction firms operating smart cities, highways, railways, ports, airports, and metro networks.</li><li>Telecom service providers, ISPs, and data centers. </li><li>Cloud service providers (CSPs), VPN providers, and IT outsourcing firms.</li></ul>Infrastructure and energy companies handling IT and Operational Technology (OT) networks fall under these directives." },
            {
                id: 4, title: "Is compliance mandatory?", description: `<ul style="list-style: none; padding-left: 0;">
    <li style="display: flex; align-items: flex-start; gap: 10px; margin-left: 20px;">
        <span style="font-size: 20px; position: relative; top: 2px;">✅</span>
        <span>Yes, compliance is mandatory. Non-compliance can result in legal actions, penalties, and potential operational restrictions under the IT Act, 2000.</span>
    </li>
</ul>

` },
            { id: 5, title: "How often is an audit required?", description: "<ul><li> Organizations must conduct regular security audits to ensure compliance. </li><li>Security logs must be retained for 180 days and must be made available to CERT-In when required.</li><li>Cyber incident reporting must be done within 6 hours of detection.</li><li>Organizations must ensure continuous monitoring of critical systems.</li><li>Audits must be conducted at least annually or as per CERT-In’s additional requirements.</li></ul>" },
            {
                id: 6, title: "What are the key requirements?", description: `<ul style="list-style: none; padding-left: 0;">
    <li style="display: flex; align-items: center; gap: 10px; margin-left: 20px;">
        <span style="font-size: 24px; position: relative; top: 5px; margin-left: -14px;">*</span>
        <span>The CERT-In Cybersecurity Directions, 2022 include the following mandatory requirements:</span>
    </li>
</ul>

<b>A. Incident Reporting (Within 6 Hours)</b>
<ul style="list-style: none; padding-left: 20px;">
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span style="font-size: 18px;">✅</span>
        <span>Organizations must report cyber incidents within 6 hours of detection to CERT-In.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span style="font-size: 18px;">✅</span>
        <span>Multi-Layered Network Security Architecture – Implement firewalls, Zero Trust Architecture (ZTA), and OT segmentation.</span>
    </li>
</ul>

<b>B. Log Retention (180 Days in India)</b>
<ul style="list-style: none; padding-left: 20px;">
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span style="font-size: 18px;">✅</span>
        <span>All organizations must store system logs for at least 180 days within Indian borders.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span style="font-size: 18px;">✅</span>
        <span>Real-time fraud risk monitoring and detection systems.</span>
    </li>
</ul>

<b>C. Time Synchronization</b>
<ul style="list-style: none; padding-left: 20px;">
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span style="font-size: 18px;">✅</span>
        <span>Organizations must synchronize their network time with National Informatics Centre (NIC) or National Physical Laboratory (NPL) servers.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span style="font-size: 18px;">✅</span>
        <span>Robust business continuity plans to handle cyber incidents.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span style="font-size: 18px;">✅</span>
        <span>Periodic disaster recovery drills and testing.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span style="font-size: 18px;">✅</span>
        <span>24x7 availability of critical payment infrastructure.</span>
    </li>
</ul>

<b>D. Cybersecurity Measures for VPN, Cloud & IT Service Providers</b>
<ul style="list-style: none; padding-left: 20px;">
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span style="font-size: 18px;">✅</span>
        <span>VPN providers, data centers, and cloud service providers must store user details (e.g., name, IP address, usage patterns) for 5 years.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span style="font-size: 18px;">✅</span>
        <span>This helps in tracking cybercriminal activities across critical sectors.</span>
    </li>
</ul>

<b>E. Security Hardening & Incident Management</b>
<ul style="list-style: none; padding-left: 20px;">
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span style="font-size: 18px;">✅</span>
        <span>Organizations must implement strict access controls, firewalls, and endpoint protection.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span style="font-size: 18px;">✅</span>
        <span>Regular vulnerability assessments and penetration testing (VAPT) are mandatory.</span>
    </li>
</ul>

<b>F. Security Audits & Compliance Reporting</b>
<ul style="list-style: none; padding-left: 20px;">
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span style="font-size: 18px;">✅</span>
        <span>Entities must conduct periodic security audits to ensure adherence to CERT-In regulations.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span style="font-size: 18px;">✅</span>
        <span>Organizations must submit audit reports to regulatory bodies when required.</span>
    </li>
</ul>
` },

            {
                id: 7,
                title: "Where can I find the official regulation?",
                description: `The official CERT-In Cybersecurity Directions, 2022 can be accessed at: <br><br>
              📌 Official Source:
                <ul><li> CERT-In Official Website: https://www.cert-in.org.in</li>
                <li> Ministry of Electronics & Information Technology (MeitY): https://www.meity.gov.in</li>
                <li> Organizations can also request detailed compliance documentation directly from CERT-In.</li></ul>

       
                `
            },
            {
                id: 8,
                title: " 	What’s the implication to the Indian Energy & Infrastructure sector?",
                description: `For India’s Energy & Infrastructure sector, these cybersecurity mandates have significant operational and financial implications:  <br><br>
     
<ul style="list-style: none; padding-left: 0;">
    <li style="display: flex; align-items: center; gap: 10px; margin-left: 20px;">
        <span>✅</span>
        <span>Cybersecurity Compliance Becomes Core to Energy Security</span>
    </li>
    <ul>
    <li>
        <span>Mandatory security audits, log retention, and real-time threat monitoring will enhance power sector resilience.</span>
    </li></ul>

    <li style="display: flex; align-items: center; gap: 10px; margin-left: 20px;">
        <span>✅</span>
        <span>Increased Investments in Cybersecurity & Risk Management</span>
    </li>
    <ul>
    <li>
        <span>Smart grids, IoT-enabled energy solutions, and AI-driven power optimization require secure network infrastructures.</span>
    </li></ul>

    <li style="display: flex; align-items: center; gap: 10px; margin-left: 20px;">
        <span>✅</span>
        <span>SCADA and OT Security Becomes a Top Priority</span>
    </li>
    <ul>
    <li>
        <span>Grid operators and renewable energy firms must implement strict security controls for SCADA and OT environments.</span>
    </li></ul>

    <li style="display: flex; align-items: center; gap: 10px; margin-left: 20px;">
        <span>✅</span>
        <span>Cyber Threats Pose a Direct Risk to Energy Supply Chains</span>
    </li>
    <ul><li>
        <span>Ransomware, DDoS attacks, and cyber espionage targeting energy companies must be mitigated through proactive threat intelligence.</span>
    </li></ul>

    <li style="display: flex; align-items: center; gap: 10px; margin-left: 20px;">
        <span>✅</span>
        <span>Regulatory Penalties for Non-Compliance</span>
    </li>
    <ul>
    <li>
        
        <span>Power sector companies failing to comply with cybersecurity requirements risk operational restrictions and financial penalties.</span>
    </li></ul>

    <li style="display: flex; align-items: center; gap: 10px; margin-left: 20px;">
        <span>✅</span>
        <span>Alignment with India's Clean Energy & Digital Transformation Goals</span>
    </li>
    <ul>
    <li>
        <span>Ensuring secure, cyber-resilient energy management systems is crucial for India’s transition to clean and digital energy solutions.</span>
    </li></ul>
</ul>
                `
            },


        ],
        tab4: [

            { id: 1, title: " 	What is this regulation?", description: "<ul><li>The Energy Conservation Act, 2001, is India’s primary legislation for promoting energy efficiency and conservation. The Act was amended in 2022 to include provisions related to carbon trading, energy efficiency in industries, and clean energy transition. </li><li>While cybersecurity compliance is not explicitly covered in the original Act, the growing reliance on smart grids, SCADA (Supervisory Control and Data Acquisition) systems, and digital power infrastructure has led to the integration of cybersecurity mandates through related policies issued by regulatory bodies like the Bureau of Energy Efficiency (BEE), Central Electricity Authority (CEA), and CERT-In.</li><b>Cyber compliance in the power sector is increasingly being enforced under:</b><ul><li>The Energy Conservation Act, 2001 (as amended in 2022)</li><li>CEA (Cyber Security in Power Sector) Guidelines, 2021 </li><li>CERT-In Cybersecurity Directions, 2022 </li><li>NCIIPC Guidelines for Critical Infrastructure Protection </li></ul></ul>These frameworks work together to ensure that digital infrastructure in India’s power sector remains secure and resilient." },

            { id: 2, title: "Who is the regulatory body?", description: "<ul><li> The primary regulatory bodies responsible for enforcing cybersecurity compliance in the power sector under the Energy Conservation Act, 2001, and other related regulations include: </li><li>Bureau of Energy Efficiency (BEE) – Oversees overall energy efficiency initiatives.</li><li>Ministry of Power (MoP), Government of India – Sets policies for power sector security and operations.</li><li>Central Electricity Authority (CEA) – Issues cybersecurity guidelines specifically for power sector infrastructure.</li><li>National Critical Information Infrastructure Protection Centre (NCIIPC) – Protects power sector assets designated as Critical Information Infrastructure (CII).</li><li>Indian Computer Emergency Response Team (CERT-In) – Ensures cybersecurity compliance and incident reporting.</li><li>National Critical Information Infrastructure Protection Centre (NCIIPC) – Protects power sector assets designated as Critical Information Infrastructure (CII).</li></ul>" },
            { id: 3, title: "Who does this apply to?", description: "<ul><li>The cybersecurity requirements under the Energy Conservation Act and related frameworks apply to: </li><li>Power Generation Companies – Including thermal, hydro, nuclear, solar, and wind power plants.</li><li>Transmission & Distribution Utilities – State electricity boards, grid operators, and private sector utilities.</li><li>Renewable Energy Firms – Including solar parks, wind farms, and clean energy infrastructure.</li><li>Smart Grid Operators – Entities managing SCADA, IoT, and AI-driven power infrastructure.</li><li>Energy-intensive Industries – Required to implement energy efficiency and cybersecurity measures.</li><li>Energy Exchange & Carbon Market Participants – Trading in energy credits and carbon markets.</li></ul>" },
            {
                id: 4, title: "Is compliance mandatory?", description: `<ul style="list-style: none; padding-left: 0;">
    <li style="display: flex; align-items: center; gap: 10px;">
        <span>✅</span>
        <span>Yes, compliance with energy efficiency and cybersecurity provisions is mandatory for all organizations operating in the power sector.</span>
    </li>
</ul>

                <ul><li> CEA Cyber Security in Power Sector Guidelines, 2021 mandates cybersecurity measures.</li><li>CERT-In Cybersecurity Directions, 2022 enforce incident reporting and security logging.</li><li>NCIIPC Guidelines are applicable to power sector assets designated as Critical Information Infrastructure (CII).</li></ul> Failure to comply can lead to legal penalties, operational restrictions, and financial liabilities. ` },
            { id: 5, title: "How often is an audit required?", description: "<ul><li> Annual cybersecurity audits are mandatory under CEA Guidelines.</li><ul><li>Real-time monitoring and logging must be implemented for critical assets.</li><li>CERT-In mandates a minimum 180-day log retention for compliance verification.</li><li>Security assessments are required before launching new smart grid or power management solutions. </li></ul></ul>" },
            { id: 6, title: "What are the key requirements?", description: "<span style='font-size: 24px; display: inline-block; text-align: center; position: relative; top: 5px;margin-left:-14px'>*</span> The Energy Conservation Act and cybersecurity-related policies require organizations in the power sector to implement strict cybersecurity controls:  <br><br><b> Key Cybersecurity Requirements Under CEA Regulations:</b><br><br><b>A. Cybersecurity Governance & Compliance</b>  <ul><li>Organizations must appoint a Chief Information Security Officer (CISO).  </li><li>Implement risk management frameworks for power grids, SCADA, and IoT infrastructure.</li><li>Regular security audits and vulnerability assessments (VAPT) are required.</li></ul><b>B. Critical Infrastructure Protection</b><ul><li>Power plants and grid operators must follow NCIIPC’s Critical Infrastructure Protection (CII) guidelines. </li><li>Implement cyber resilience strategies to prevent attacks on SCADA and OT networks.</li></ul><b>C. Smart Grid & SCADA Security</b> <ul><li>Secure smart meters, remote control systems, and energy automation networks.</li><li>Implement firewalls, intrusion detection systems (IDS/IPS), and Zero Trust Architecture.</li></ul><b>D. CERT-In Cybersecurity Compliance </b> <ul><li>Report all cyber incidents within 6 hours to CERT-In.</li><li>Maintain system logs for at least 180 days in India.</li></ul><b>E. Secure Supply Chain Management </b><ul><li>Vendors and contractors must comply with power sector cybersecurity policies.</li><li>Implement security controls for third-party access to power infrastructure.</li></ul> " },

            {
                id: 7,
                title: "Where can I find the official regulation?",
                description: `The official regulations and cybersecurity frameworks related to Energy Conservation and Cybersecurity Compliance in the Power Sector can be found at:  <br><br>
              📌 Official Source:
                <ul><li>     Bureau of Energy Efficiency (BEE): https://beeindia.gov.in</li>
                <li>Ministry of Power (MoP), India: https://powermin.gov.in</li>
           
                <li>  CERT-In (Indian Computer Emergency Response Team) – https://www.cert-in.org.in/ </li>

                <li>National Critical Information Infrastructure Protection Centre (NCIIPC) – https://www.nciipc.gov.in/ </li>
           
                <li>  Cybersecurity Guidelines for Smart Grids & Energy Infrastructure – Available from sector-specific regulators and BIS (Bureau of Indian Standards).</li>
           
                <li>Organizations must refer to official documentation and industry-specific cybersecurity guidelines for detailed compliance frameworks.</li></ul>
               
                `
            },
            {
                id: 8,
                title: " 	What’s the implication to the Indian Energy & Infrastructure sector?",
                description: `For India’s Energy & Infrastructure sector, these cybersecurity mandates have significant operational and financial implications:  <br><br>
            Key Implications for Energy & Infrastructure:
  <ul style="list-style: none; padding-left: 0;">
    <li style="display: flex; align-items: center; gap: 10px;">
        <span>✅</span>
        <span>Cybersecurity Compliance Becomes Core to Energy Security</span>
    </li>
    <ul>
    <li>
        <span>Mandatory security audits, log retention, and real-time threat monitoring will enhance power sector resilience.</span>
    </li>
</ul>
    <li style="display: flex; align-items: center; gap: 10px;">
        <span>✅</span>
        <span>Increased Investments in Cybersecurity & Risk Management</span>
    </li>
    <ul>
    <li>
        <span>Smart grids, IoT-enabled energy solutions, and AI-driven power optimization require secure network infrastructures.</span>
    </li></ul>

    <li style="display: flex; align-items: center; gap: 10px;">
        <span>✅</span>
        <span>SCADA and OT Security Becomes a Top Priority</span>
    </li>
    <ul>
    <li>
        <span>Grid operators and renewable energy firms must implement strict security controls for SCADA and OT environments.</span>
    </li></ul>

    <li style="display: flex; align-items: center; gap: 10px;">
        <span>✅</span>
        <span>Cyber Threats Pose a Direct Risk to Energy Supply Chains</span>
    </li>
    <ul>
    <li>
        <span>Ransomware, DDoS attacks, and cyber espionage targeting energy companies must be mitigated through proactive threat intelligence.</span>
    </li></ul>
</ul>

                `
            },


        ],
        tab5: [

            { id: 1, title: " 	What is this regulation?", description: "<ul><li>The Smart Grid Cybersecurity Guidelines issued by the India Smart Grid Forum (ISGF) provide a framework for securing India's smart grid infrastructure from cyber threats. These guidelines focus on the cybersecurity of critical energy assets, smart meters, SCADA systems, and IoT-enabled power grids. <ul><li>The guidelines emphasize: </li><li>Risk-based cybersecurity approaches for power utilities. </li><li>Integration of security measures in smart grid architecture. </li><li>Incident detection, response, and recovery frameworks.</li><li>Compliance with global best practices (ISO 27001, NIST, IEC 62443, etc.). </li></ul></ul>They aim to ensure the resilience, reliability, and security of India's power distribution and transmission networks." },

            { id: 2, title: "Who is the regulatory body?", description: "<ul><li> The India Smart Grid Forum (ISGF), under the Ministry of Power, Government of India, is the primary organization behind these guidelines.</li>Additionally, other key regulatory bodies involved in enforcing cybersecurity for smart grids include: <br> Central Electricity Authority (CEA) – Issues cybersecurity regulations for power sector utilities. <ul><li>Bureau of Energy Efficiency (BEE) – Promotes secure energy management systems.</li><li>Indian Computer Emergency Response Team (CERT-In) – Governs cyber incident reporting and response.</li><li>National Critical Information Infrastructure Protection Centre (NCIIPC) – Secures power sector CII assets.</li></ul></ul>" },
            { id: 3, title: "Who does this apply to?", description: "The Smart Grid Cybersecurity Guidelines apply to:  <br> Power Transmission & Distribution Utilities – State electricity boards, private power distributors. <ul><li>Smart Grid Infrastructure Providers – Companies managing smart meters, automation, and grid modernization.</li><li>Renewable Energy Projects – Solar, wind, hydro projects with IoT-enabled grid connections.</li><li>SCADA & Industrial Control System (ICS) Operators – Organizations managing critical energy control systems.</li><li>IoT & Smart Metering Companies – Firms providing smart energy solutions.</li><li>Energy Data Management & Cloud Service Providers – Companies handling grid data analytics & automation.</li></ul> Independent Power Producers (IPPs) – Private-sector firms generating electricity using digital technologies." },
            {
                id: 4, title: "Is compliance mandatory?", description: `<ul style="list-style: none; padding-left: 0;">
                <li style="display: flex; align-items: top">
                    <span>✅</span>
                    <span>Yes, compliance is mandatory for utilities and entities involved in smart grid operations, as these are part of Critical Information Infrastructure (CII).</span>
                    </li>
                </ul>
 
                <ul><li>  CEA Cybersecurity Guidelines (2021) align with ISGF recommendations and mandate smart grid security.</li> 
                <li> CERT-In’s Cybersecurity Directions (2022) enforce incident reporting and cyber hygiene standards.</li>
                 <li> Non-compliance may lead to regulatory actions, security breaches, and legal consequences.</li></ul>` },
            { id: 5, title: "How often is an audit required?", description: "<ul><li> Annual cybersecurity audits are required for smart grid operators, SCADA, and energy control systems.</li><ul><li>Penetration Testing & Vulnerability Assessments (VAPT) must be conducted every six months </li><li>Continuous monitoring and real-time log analysis are required to detect and respond to threats. </li><li>Incident reports must be submitted to CERT-In and NCIIPC within 6 hours of a cyber event.</li></ul><ul>" },
            { id: 6, title: "What are the key requirements?", description: "<span style='font-size: 24px; display: inline-block; text-align: center; position: relative; top: 5px;margin-left:-14px'>*</span> The Smart Grid Cybersecurity Guidelines define best practices across key areas:<br><br><b>A. Cybersecurity Governance & Risk Management </b>  <ul><li> Appoint a Chief Information Security Officer (CISO) for power utilities. </li><li>Implement ISO 27001 and IEC 62443-compliant security frameworks.</li><li>Define incident response and cyber risk assessment policies.</li></ul><b> B. Smart Grid Infrastructure Security </b><ul><li>Secure smart meters, IoT devices, and AMI (Advanced Metering Infrastructure).</li><li>Implement role-based access controls (RBAC) and Zero Trust Architecture. </li></ul><b>C. SCADA & Industrial Control System (ICS) Protection</b><ul><li>Deploy firewalls, Intrusion Detection & Prevention Systems (IDPS), and real-time monitoring.</li><li>Secure remote access protocols and prevent unauthorized device connections.</li></ul><b>D. Compliance with CERT-In & CEA Guidelines</b><ul><li>Report cyber incidents within 6 hours to CERT-In.</li><li>Maintain 180-day system logs and provide them to authorities if required.</li></ul><b>E. Secure Supply Chain & Vendor Management</b><ul><li>Ensure third-party vendors follow cybersecurity standards.</li><li>Conduct regular security audits on contractors handling power infrastructure.</li></ul><b> F. Cybersecurity Awareness & Training. </b><ul><li>Conduct regular cybersecurity training for power sector employees.</li><li>Simulate cyberattack drills to test incident response readiness.</li></ul>" },

            {
                id: 7,
                title: "Where can I find the official regulation?",
                description: `The Smart Grid Cybersecurity Guidelines (ISGF) can be accessed from: <br><br>
              📌 Official Source:

                <ul><li>     India Smart Grid Forum (ISGF): https://www.indiasmartgrid.org</li>

             <li>  Central Electricity Authority (CEA): https://cea.nic.in</li>
           
                <li> CERT-In (Cybersecurity Guidelines for Smart Grids & Power Infrastructure): https://www.cert-in.org.in</li>
           
                <li>   National Critical Information Infrastructure Protection Centre (NCIIPC) – https://www.nciipc.gov.in/ </li>
                <li>   Organizations handling smart grid cybersecurity should contact ISGF and CEA for specific compliance frameworks.</li></ul>
                `
            },
            {
                id: 8,
                title: " 	What’s the implication to the Indian Energy & Infrastructure sector?",
                description: `For India’s Energy & Infrastructure sector, the Smart Grid Cybersecurity Guidelines have major operational and regulatory implications: <br><br>
            Key Implications for Energy & Infrastructure:
<ul style="list-style: none; padding-left: 0;">
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span>✅</span>
        <span>Stronger Cyber Resilience for Power Sector</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span>✅</span>
        <span>Ensuring secure, uninterrupted electricity supply by reducing cyber risks.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span>✅</span>
        <span>Compliance with National & Global Standards</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span>✅</span>
        <span>Power companies must align with CEA, CERT-In, and NCIIPC frameworks to avoid legal consequences.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span>✅</span>
        <span>Cyber Protection for Smart Meters & IoT Devices</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span>✅</span>
        <span>Tamper-proof smart grids and automated energy networks to prevent data breaches.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span>✅</span>
        <span>Secure Integration of Renewable Energy & Smart Cities</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 10px;">
        <span>✅</span>
        <span>Better Collaboration between Power & IT Sectors</span>
    </li>
</ul>
          Power utilities must invest in cybersecurity solutions, SOCs, and AI-driven threat detection.    
                `
            },


        ],


    };

    const [toggle, setToggle] = useState(null);

    const updateToggle = (id) => {
        setToggle(toggle === id ? null : id);
    };
    return (
        <div><div style={{ background: "rgb(236 115 34)", marginTop: "-25px", height: "60px", }} className="aero-title-card">
            <h1 style={{ textAlign: "center", paddingTop: "10px", marginBottom: "40px" }}>ENERGY INDUSTRY</h1>
        </div>
            <div style={{ marginTop: '100px' }}>
                <h1 style={{ textAlign: "center" }}>
                    <span style={{ color: "rgb(236 115 34)" }}>Regulatory </span>Compliance FAQ's
                </h1>

                <div style={{ ...styles.container, ...(window.innerWidth <= 768 ? styles.mobileContainer : {}) }} className="aeroducoment-data">
                    {/* Tab Navigation */}
                    <div style={{ ...styles.tabNav, ...(window.innerWidth <= 768 ? styles.mobileTabNav : {}) }} className="eneg-nav-data-tab">
                        <button
                            style={{
                                ...styles.tabButton,
                                ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                                ...(activeTab === "tab1" ? styles.activeTabButton : {}),
                            }}
                            onClick={() => handleTabClick("tab1")}
                            className="tab-button-width"
                            onMouseEnter={(e) => {
                                if (activeTab !== "tab1") {
                                    e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                    e.currentTarget.style.color = "#fff"; // Change text to white
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (activeTab !== "tab1") {
                                    e.currentTarget.style.backgroundColor = ""; // Revert background
                                    e.currentTarget.style.color = ""; // Revert text color
                                }
                            }}
                        >
                            Central Electricity Authority (Cyber Security in Power Sector) Regulations, 2024
                        </button>
                        <button
                            style={{
                                ...styles.tabButton,
                                ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                                ...(activeTab === "tab2" ? styles.activeTabButton : {}),
                            }}
                            onClick={() => handleTabClick("tab2")}
                            className="tab-button-width"
                            onMouseEnter={(e) => {
                                if (activeTab !== "tab2") {
                                    e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                    e.currentTarget.style.color = "#fff"; // Change text to white
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (activeTab !== "tab2") {
                                    e.currentTarget.style.backgroundColor = ""; // Revert background
                                    e.currentTarget.style.color = ""; // Revert text color
                                }
                            }}
                        >
                            NCIIPC Guidelines for Critical Information Infrastructure (CII) Protection


                        </button>
                        <button
                            style={{
                                ...styles.tabButton,
                                ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                                ...(activeTab === "tab3" ? styles.activeTabButton : {}),
                            }}
                            onClick={() => handleTabClick("tab3")}
                            className="tab-button-width"
                            onMouseEnter={(e) => {
                                if (activeTab !== "tab3") {
                                    e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                    e.currentTarget.style.color = "#fff"; // Change text to white
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (activeTab !== "tab3") {
                                    e.currentTarget.style.backgroundColor = ""; // Revert background
                                    e.currentTarget.style.color = ""; // Revert text color
                                }
                            }}
                        >
                            CERT-In Cybersecurity Directives, 2022
                        </button>
                        <button
                            style={{
                                ...styles.tabButton,
                                ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                                ...(activeTab === "tab4" ? styles.activeTabButton : {}),
                            }}
                            onClick={() => handleTabClick("tab4")}
                            className="tab-button-width"
                            onMouseEnter={(e) => {
                                if (activeTab !== "tab4") {
                                    e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                    e.currentTarget.style.color = "#fff"; // Change text to white
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (activeTab !== "tab4") {
                                    e.currentTarget.style.backgroundColor = ""; // Revert background
                                    e.currentTarget.style.color = ""; // Revert text color
                                }
                            }}
                        >
                            Energy Conservation Act, 2001 – Cyber Compliance for Power Sector
                        </button>
                        <button
                            style={{
                                ...styles.tabButton,
                                ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                                ...(activeTab === "tab5" ? styles.activeTabButton : {}),
                            }}
                            onClick={() => handleTabClick("tab5")}
                            className="tab-button-width"
                            onMouseEnter={(e) => {
                                if (activeTab !== "tab5") {
                                    e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                                    e.currentTarget.style.color = "#fff"; // Change text to white
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (activeTab !== "tab5") {
                                    e.currentTarget.style.backgroundColor = ""; // Revert background
                                    e.currentTarget.style.color = ""; // Revert text color
                                }
                            }}
                        >
                            Smart Grid Cybersecurity Guidelines (ISGF)
                        </button>


                    </div>

                    {/* Tab Content */}
                    <div
                        style={{
                            ...styles.card,
                            ...(window.innerWidth <= 768 ? styles.mobileCard : {}),
                            // height: toggle ? "auto" : "450px", 
                            // maxHeight: toggle ? "870px" : "450px", 
                            transition: "max-height 0.3s ease", // Transition for smooth expansion
                            overflowY: "auto", // Enable vertical scrolling when content overflows
                            paddingTop: "20px", // Padding to prevent content from sticking to the top
                        }}
                        className="aero-card-data"
                    >
                        <div className="list-tab data-list-tab" style={{ width: "100%", padding: 0, gap: "10px", flexWrap: "wrap" }}>
                            {tabContent[activeTab].map(({ id, title, description }, index) => (
                                <div key={id} className="mb-3" style={{ width: "100%", flexWrap: "wrap", }}>
                                    {/* Clickable Title */}
                                    <div
                                        className="p-3 rounded cursor-pointer d-flex justify-content-between align-items-center bg-light"
                                        onClick={() => updateToggle(id)}  // Enable toggle for all items, including id: 1
                                        style={{
                                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",  // Apply same box shadow to all items
                                            width: "100%",
                                            position: "relative",  // Set the title position to relative
                                            zIndex: 1,  // Ensure title stays on top of the expanded description
                                        }}
                                    >
                                        <span
                                            className="fw-bold"
                                            style={{
                                                fontFamily: "Roboto",
                                                textAlign: "center",
                                                fontSize: "20px",
                                                color: "#000",  // Apply the same color to all items
                                                fontFamily: '"Helvetica Neue", Arial, sans-serif',
                                            }}
                                        >
                                            {title}
                                        </span>
                                        <span style={{ fontSize: "20px" }}>
                                            {toggle === id ? "-" : "+"} {/* Toggle + or - */}
                                        </span>
                                    </div>

                                    {/* Conditionally Render Description Below When Clicked */}
                                    {toggle === id && (
                                        <div className="p-3 mt-2 bg-light rounded" style={{ width: "100%", boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)", textAlign: "justify" }}>
                                            <span dangerouslySetInnerHTML={{ __html: description }} />
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Dot Navigation for 3 Tabs */}

            </div>
        </div>
    );
};

export default DocumentEnrgytabone;
